/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type NotModified = {
  location: string;
};

/** @internal */
export const NotModified$inboundSchema: z.ZodMiniType<NotModified, unknown> = z
  .object({
    location: z.string(),
  });

export function notModifiedFromJSON(
  jsonString: string,
): SafeParseResult<NotModified, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => NotModified$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'NotModified' from JSON`,
  );
}
